import { FC } from 'react';

import { Control, Controller, UseFormRegister, FieldValues } from 'react-hook-form';
import Title from 'components/Common/Title';
import { TextareaAutosize as BaseTextareaAutosize } from '@mui/base/TextareaAutosize';
import styled from 'styled-components';

const Textarea = styled(BaseTextareaAutosize)(
    () => `
    box-sizing: border-box;
    width: 100%;
    font-family: 'IBM Plex Sans', sans-serif;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    padding: 8px 12px;
    resize: none;
    border: none;

    // firefox
    &:focus-visible {
      outline: 0;
    }
  `,
);

interface FormFieldType<T extends FieldValues = FieldValues> {
    name: string;
    title?: string;
    control: Control<T>;
    register: UseFormRegister<T>;
}

const FormTextarea: FC<FormFieldType> = (props) => {
    const { control, name, title, register } = props;

    return (
        <Controller
            control={control}
            name={name}
            render={({ fieldState: { error } }) => (
                <>
                    {title && <Title title={title} />}
                    <Textarea maxRows={10} minRows={10} {...register(name)} />
                    {error && <div className="error-message">{error.message}</div>}
                </>
            )}
        />
    );
};

export default FormTextarea;
